<ng-container >
  <div [hidden]="!(loadingService.isLoading$ | async)" class="loader loader-bar is-active" data-text="Please wait"></div>
</ng-container>
<p-messages></p-messages>
<p-toast></p-toast>
<router-outlet></router-outlet>
